<div class="container-inco inco-admin">
  <div class="header-container">
    <div class="header-left">
      <h2>{{title}}</h2>
    </div>
  </div>
  <div>

    <mat-tab-group orientation="vertical" #tabGroup [selectedIndex]="0" animationDuration="0ms">
      <mat-tab label="Multiproject Manager">
        <div class="inner-tcontainer-tab">
          <app-multiproject-manager></app-multiproject-manager>
        </div>
      </mat-tab>
      <mat-tab label="Functional assignment">
        <div class="inner-tcontainer-tab">
          <app-functional-assignment></app-functional-assignment>
        </div>
      </mat-tab>
      <mat-tab label="M / E split BUD by OPL">
        <ng-template matTabContent>
          <div class="inner-tcontainer-tab">
            <app-maintenance-expansion-config mode="OPL"></app-maintenance-expansion-config>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab label="M / E split ACT">
        <ng-template matTabContent>
          <div class="inner-tcontainer-tab">
            <app-maintenance-expansion-config mode="ACT"></app-maintenance-expansion-config>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab label="Recent Project tracker">
        <div class="inner-tcontainer-tab">
          <app-recent-projects-tracker></app-recent-projects-tracker>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>